import type { SearchAction, SearchActionProps } from "./search-action.types";

export function getSearchAction({
  target,
  queryInput = "required name=search_term_string",
}: SearchActionProps): SearchAction {
  return {
    "@type": "SearchAction",
    target,
    "query-input": queryInput,
  };
}